import { FC, Fragment } from 'react';

import { Popover, Transition } from '@headlessui/react';
import { cn, downloadURI } from 'utils/helpers';
import { Attachment } from 'utils/types';
import Carousel from 'ui/components/common/Carousel';
import { MdClose } from 'react-icons/md';

type PreviewProps = {
  open: boolean;
  closeModal: () => void;
  files: Pick<
    Attachment,
    'fileUrl' | 'fileType' | 'fileThumbnail' | 'fileName'
  >[];
  initialSlide: number;
};

const Preview: FC<PreviewProps> = ({
  open,
  closeModal,
  files,
  initialSlide,
}) => {
  return (
    <Transition appear show={open} as={Fragment}>
      <Popover className={'fixed z-50'}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Popover.Overlay
            className={cn(
              'fixed top-0 left-0 w-full h-screen',
              'overflow-y-auto',
              'flex items-center justify-center',
              'bg-[#E9EDF899] backdrop-blur-sm',
            )}
          >
            <Popover.Panel className={'mx-5'}>
              <div
                className={cn(
                  'flex items-center justify-between',
                  'bg-fill-primary px-4 py-2.5',
                  'rounded-t-[6px]',
                )}
              >
                <div className="text-sm font-semibold leading-5 tracking-[0.06em]">
                  Preview
                </div>
                <div className="font-semibold">
                  <button onClick={closeModal} type="button" className="ml-5">
                    <MdClose
                      className={cn(
                        'h-3 w-3 text-secondary-dark hover:text-danger-base transition',
                      )}
                    />
                  </button>
                </div>
              </div>
              <div
                className={cn(
                  'bg-fill-tertiary',
                  'flex gap-4 flex-col divide-y divide-separator-primary',
                )}
              >
                <Carousel
                  onDownload={downloadURI}
                  showFilename
                  options={{
                    startIndex: initialSlide,
                  }}
                  slides={files}
                />
              </div>
            </Popover.Panel>
          </Popover.Overlay>
        </Transition.Child>
      </Popover>
    </Transition>
  );
};

export default Preview;
